// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { Box, Typography } from '@mui/material';
// Others
import { formatCurrencyUSD } from '~/utils/helper/common';
// Styles, images, icons
import styles from './StatisticTotal.module.scss';
import { icons } from '~/assets';

type Props = {
  title: string;
  total: number;
  percent: number;
  icon: string;
  backgroundColor: string;
  isDescription?: boolean;
};

const cx = classNames.bind(styles);

const StatisticTotal = (props: Props) => {
  //#region Destructuring Props
  const { title, total, percent, icon, backgroundColor, isDescription } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/dashboard']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} className={cx('container')} style={{ backgroundColor: backgroundColor }}>
      <Box className={cx('header')}>
        <Box className={cx('titleGroup')}>
          <Typography className={cx('title')}>{title}</Typography>

          <img src={icon} alt={'common_alt_img'} />
        </Box>

        <Typography className={cx('total')}>{formatCurrencyUSD({ value: total })}</Typography>
      </Box>

      <Box className={cx('percentGroup')}>
        <img src={icons.statisticIconUp} alt={'common_alt_img'} />

        <Typography className={cx('percent')}>
          {`${percent}%`}
          {isDescription && <Typography className={cx('description')}>{t('statistic_description')}</Typography>}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatisticTotal;
